<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/WorkEnvSurvey/Details/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>